module.exports = new __parcel__URL__("infoIcon2.6bc68ed2.svg").toString();